import { c as _c } from "react/compiler-runtime";
import { CoursesApiInterface } from 'modules/courses/students/types/student-filter-interface';
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
import { STUDENTS_API } from 'modules/courses/students/api/students-api';
export function useStudentCourses() {
  const $ = _c(2);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== user) {
    t0 = () => {
      if (user) {
        return `${STUDENTS_API}/filter/course`;
      }
    };
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSWR(t0, baseFetcher);
}